import { lazy } from "react";
import * as XLSX from "xlsx";

export const sections = [
  {
    id: "beneficiaries",
    title: "Projeto e Beneficiário(s)",
    component: lazy(() => import("./01_Beneficiaries")),
  },
  {
    id: "stepFraming",
    title: "Enquadramento STEP",
    component: lazy(() => import("./02_StepFraming")),
  },
  {
    id: "beneficiaryData",
    title: "Dados do Beneficiário",
    component: lazy(() => import("./03_BeneficiaryData")),
  },
  {
    id: "economic",
    title: "Unidade Económica",
    component: lazy(() => import("./04_EconomicUnit")),
  },
  {
    id: "marketAnalysis",
    title: "Análise Mercado",
    component: lazy(() => import("./05_MarketAnalysis")),
  },
  {
    id: "balance",
    title: "Balanço e DR",
    component: lazy(() => import("./06_BalanceDR")),
  },
  {
    id: "project",
    title: "Dados do Projeto",
    component: lazy(() => import("./07_ProjectData")),
  },
  {
    id: "operation",
    title: "Caracterização da Operação",
    component: lazy(() => import("./08_OperationDescription")),
  },
  {
    id: "actions",
    title: "Detalhe das Ações",
    component: lazy(() => import("./09_Actions")),
  },
  {
    id: "activities",
    title: "Atividades e Indicadores",
    component: lazy(() => import("./10_Activities")),
  },
  {
    id: "technicians",
    title: "Pessoal técnico",
    component: lazy(() => import("./11_Technicians")),
  },
  {
    id: "team",
    title: "Equipa",
    component: lazy(() => import("./12_TechniciansCosts")),
  },
  { id: "costs", title: "Custos", component: lazy(() => import("./13_Costs")) },
  {
    id: "amortizations",
    title: "Amortização",
    component: lazy(() => import("./14_Amortization")),
  },
  {
    id: "financing",
    title: "Financiamento",
    component: lazy(() => import("./15_Financing")),
  },
  {
    id: "selectionCriteria",
    title: "Critérios de Seleção",
    component: lazy(() => import("./16_SelectionCriteria")),
  },
  {
    id: "declarations",
    title: "Declarações",
    component: lazy(() => import("./17_Declarations")),
  },
];

export const importFiles = {
  // Mérito: (workbook, formData, jsonData, handleChange, setToast) => {
  //   const companyLabels = ["Líder", "Co-P2", "Co-P3", "Co-P4"];
  //   let companyCounter = 0;
  //   let enesiisCounter = 0;
  //   const balaceData = {};
  //   const drData = {};
  //   const financingData = {};
  //   formData["beneficiaries"]?.forEach((ben) => {
  //     const { nature, id, name } = ben;
  //     if (!nature) return;
  //     if (nature === "01") {
  //       // Company
  //       const label = companyLabels[companyCounter++];
  //       const balanceSheet = workbook.Sheets[`Balanço ${label}`];
  //       const accountsHeader = XLSX.utils
  //         .sheet_to_json(balanceSheet, {
  //           range: "B7:K7",
  //           header: 1,
  //           blankrows: false,
  //           defval: "",
  //         })[0]
  //         ?.map((value) => value?.toString().slice(-2));
  //       balaceData[id] = XLSX.utils.sheet_to_json(balanceSheet, {
  //         range: "B9:K71",
  //         blankrows: true,
  //         defval: "",
  //         skipHidden: false,
  //         header: accountsHeader,
  //       });
  //       const drSheet = workbook.Sheets[`DR ${label}`];
  //       drData[id] = XLSX.utils.sheet_to_json(drSheet, {
  //         range: "B5:K34",
  //         blankrows: true,
  //         defval: "",
  //         skipHidden: false,
  //         header: accountsHeader,
  //       });
  //       const financeSheet = workbook.Sheets[`Financiamento ${label}`];
  //       financingData[id] = XLSX.utils.sheet_to_json(financeSheet, {
  //         range: "K4:K22",
  //         blankrows: true,
  //         defval: "",
  //         skipHidden: false,
  //         header: ["value"],
  //       });
  //     }
  //     if (nature === "02") {
  //       // Enesii
  //       const financeSheet = workbook.Sheets[`Financiamento ENESII`];
  //       const cols = ["J", "V", "AH", "AT"];
  //       const currentCol = cols[enesiisCounter];
  //       financingData[id] = XLSX.utils.sheet_to_json(financeSheet, {
  //         range: `${currentCol}4:${currentCol}22`,
  //         blankrows: true,
  //         defval: "",
  //         skipHidden: false,
  //         header: ["value"],
  //       });
  //       enesiisCounter++;
  //     }
  //   });
  //   handleChange("balance", balaceData);
  //   handleChange("dr", drData);
  //   handleChange("financing", financingData);
  //   setToast({
  //     title: "Mérito",
  //     message: "Contas e Financimaneto foram carregadas com sucesso!",
  //     type: "success",
  //   });
  // },
};
